import { cn } from "@/lib/utils";

interface SectionCardProps {
  children: React.ReactNode;
  className?: string;
}

export function SectionCard({ children, className }: SectionCardProps) {
  return (
    <div className={cn("cy:border-gray-200 cy:rounded-lg cy:p-6", className)}>
      {children}
    </div>
  );
}
